<!--
  ~ VNCcontact+ : A new level of contact management
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="contact-dialog">
    <div class="vp-contact-mobile-floating-window floating_window summary-pane" *ngIf="totalSelectedContact > 0">
        <div class="left-container">
            <mat-icon class="close disable-select" style="color:white;font-size: 20px;" (click)="resetSelection()">close
            </mat-icon>
            <div class="checkbox-container disable-select">
                <mat-checkbox [(ngModel)]="selectAll" (change)="markAll(selectAll)"></mat-checkbox>
            </div>
            <span class="select_count disable-select">{{totalSelectedContact}}</span>
        </div>
        <div class="mobile_view">
            <mat-icon *ngIf="isCordova" class="disable-select" style="color:white" (click)="floatingOperation('shareContact','')">share
            </mat-icon>
            <mat-icon class="disable-select" style="color:#FFFFFF;" (click)="floatingOperation('delete','')">delete
            </mat-icon>
            <mat-icon class="disable-select" [matMenuTriggerFor]="headerMenuOperation" style="color:white">more_vert
            </mat-icon>
        </div>
    </div>

    <div class="contact__dialog-header" *ngIf="!isSearchView">
        <div class="mobile-back-button">
            <button mat-button (click)="close()">
                <mat-icon class="mdi-20px" fontSet="mdi" fontIcon="mdi-arrow-left"></mat-icon>
            </button>
        </div>
        <div class="header_lbl disable-select">
            {{ headerText }}
        </div>
        <div class="mobile-back-button" (click)="openSearchView(true)">
            <button mat-button>
                <mat-icon class="disable-select">search</mat-icon>
            </button>
        </div>
        <div class="mobile-back-button">
            <button mat-button [matMenuTriggerFor]="listOperationMenu">
                <mat-icon class="disable-select">more_vert</mat-icon>
            </button>
        </div>
    </div>
    <div class="contact__dialog-header search-header" *ngIf="isSearchView">
        <div class="mobile-back-button">
            <button mat-button (click)="openSearchView(false);emptySearchText();">
                <mat-icon class="mdi-20px" fontSet="mdi" fontIcon="mdi-arrow-left"></mat-icon>
            </button>
        </div>
        <div class="header_lbl disable-select">
            <mat-form-field floatLabel="never">
                <input matInput #searchTextInput class="form-control" [(ngModel)]="searchText" name="label"
                    placeholder="{{ 'SEATCH_CONTACTS' | translate }}" autocomplete="nope" />
            </mat-form-field>
        </div>
        <div class="mobile-back-button">
            <button mat-button *ngIf="searchText.length > 0" (click)="emptySearchText()">
                <mat-icon class="disable-select">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="contact__dialog-body" (scroll)="scrollMoreContacts($event)">
        <div class="app-disabled" *ngIf="isLoading">
            <vp-custom-spinner></vp-custom-spinner>
        </div>
        <div class="content disable-select">
            <div *ngFor="let contact of contacts | vpSearchContact : searchText" class="contact-group-item"
                (click)="openContactDetail(contact)" vpLongPress [timeout]="700"
                (onLongPress)="$event?.preventDefault(); $event?.stopPropagation(); selectContactItem(contact)">
                <div *ngIf="!contact.isChecked" class="user-avatar-item disable-select">
                    <vp-avatar
                        [user]="{firstLastCharacters: contact.fullName?.charAt(0), color: contact.bgAvatarColor, avatarURL: contact.avatar, emails: contact.emails, jid: contact.jid}">
                    </vp-avatar>
                </div>
                <div *ngIf="contact.isChecked" class="checked-contact-item disable-select">
                    <mat-icon style="vertical-align: middle;" class="disable-select">done</mat-icon>
                </div>
                <div class="full-name disable-select">
                    {{contact.fullName}}
                </div>
            </div>
        </div>
    </div>
    <mat-menu #listOperationMenu="matMenu" [class]="'contact-plus-mat-menu'">
        <mat-list>
            <mat-list-item (click)="editList()">
                <ng-container [ngTemplateOutlet]="editIcon"></ng-container>
                <span class="disable-select">{{ 'RENAME_RENAME' | translate }}</span>
            </mat-list-item>
            <mat-list-item (click)="deleteList()">
                <ng-container [ngTemplateOutlet]="deleteIcon"></ng-container>
                <span class="disable-select">{{ 'DELETE' | translate }}</span>
            </mat-list-item>

            <mat-list-item (click)="createNewContact()">
                <svg class="user-new" width="18px" height="18px" viewBox="0 0 24 24" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Icon/product/user-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path
                            d="M6,17.85 L6,19 C6,19.5522847 5.55228475,20 5,20 C4.44771525,20 4,19.5522847 4,19 L4,17.85 L4,17.85 C4,14.8766994 8.5673946,13 12.5,13 C16.3506761,13 20.8099674,14.7993182 20.9940999,17.6656036 L21,17.85 L21,19 C21,19.5522847 20.5522847,20 20,20 C19.4477153,20 19,19.5522847 19,19 L19,17.85 L19,17.85 C19,16.540378 15.79428,15.1542503 12.9670805,15.0119699 L12.7324336,15.0030208 L12.5,15 C9.64886306,15 6.18754404,16.3913943 6.00734383,17.740716 L6,17.85 Z M12.507014,3 C14.9932903,3 17,5.01382241 17,7.5 C17,9.98617759 14.9932903,12 12.507014,12 C10.0193052,12 8,9.98473341 8,7.5 C8,5.01526659 10.0193052,3 12.507014,3 Z M12.507014,5 C11.1229794,5 10,6.12073341 10,7.5 C10,8.87926659 11.1229794,10 12.507014,10 C13.8871336,10 15,8.88318908 15,7.5 C15,6.11681092 13.8871336,5 12.507014,5 Z"
                            id="Shape" fill="#888"></path>
                    </g>
                </svg>
                <span class="disable-select">{{ 'CREATE_NEW_CONTACT' | translate }}</span>
            </mat-list-item>
            <mat-list-item (click)="addContacts()">
                <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Icon/product/user-group-add-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path
                            d="M17.0200669,15 C18.2684805,15 19.6256389,15.2698679 21.0933947,15.802083 C22.6901796,16.3810846 23.6943144,17.3096583 23.9554613,18.5874988 L23.9904987,18.7921655 L24,18.9296875 L24,20 C24,20.5522847 23.5522847,21 23,21 C22.4477153,21 22,20.5522847 22,20 L22,19.018 L21.9890465,18.9596418 C21.8769203,18.4982387 21.4565107,18.0982351 20.6136736,17.7593992 L20.4116221,17.682292 C19.1502808,17.2249238 18.019145,17 17.0200669,17 C16.4790809,17 15.8973878,17.0659418 15.2753572,17.1990199 C15.6193671,17.604295 15.8490713,18.0669129 15.9554613,18.5874988 L15.9904987,18.7921655 L16,18.9296875 L16,21 C16,21.5522847 15.5522847,22 15,22 C14.4477153,22 14,21.5522847 14,21 L14,19.018 L13.9890465,18.9596418 C13.8855454,18.5337312 13.5193649,18.1601374 12.8007277,17.838678 L12.6136736,17.7593992 L12.4116221,17.682292 C11.1502808,17.2249238 10.019145,17 9.02006689,17 C8.02016749,17 6.88120553,17.2252689 5.60551489,17.6833493 C4.61546028,18.0388623 4.13204451,18.4652381 4.01095357,18.9601165 L4,19.013 L4,21 C4,21.5522847 3.55228475,22 3,22 C2.44771525,22 2,21.5522847 2,21 L2,18.9296875 L2.00950129,18.7921655 C2.20198853,17.4057812 3.23452212,16.4097023 4.92960216,15.8010257 C6.40976437,15.2695228 7.77247466,15 9.02006689,15 C10.2447692,15 11.5741248,15.259714 13.0098825,15.7720416 L12.9296022,15.8010257 C14.4097644,15.2695228 15.7724747,15 17.0200669,15 Z M8.5,7 C9.47989383,7 10.331491,7.33426357 10.995667,7.99325071 C11.6613811,8.65376395 12,9.50303011 12,10.4804688 C12,11.4579074 11.6613811,12.3071735 10.995667,12.9676868 C10.3416985,13.6165461 9.51178209,13.9642177 8.484272,13.9993728 C7.50450726,13.9646545 6.66056681,13.6187937 6.00433302,12.9676868 C5.33861889,12.3071735 5,11.4579074 5,10.4804688 C5,9.50303011 5.33861889,8.65376395 6.00433302,7.99325071 C6.66850903,7.33426357 7.52010617,7 8.5,7 Z M17.5,7 C18.4798938,7 19.331491,7.33426357 19.995667,7.99325071 C20.6613811,8.65376395 21,9.50303011 21,10.4804688 C21,11.4579074 20.6613811,12.3071735 19.995667,12.9676868 C19.3394332,13.6187937 18.4954927,13.9646545 17.4435921,13.9993255 C16.4882179,13.9642177 15.6583015,13.6165461 15.004333,12.9676868 C14.3386189,12.3071735 14,11.4579074 14,10.4804688 C14,9.50303011 14.3386189,8.65376395 15.004333,7.99325071 C15.668509,7.33426357 16.5201062,7 17.5,7 Z M8.5,9 C8.03632428,9 7.69369569,9.13448643 7.41298981,9.41299929 C7.13382206,9.68998605 7,10.0256157 7,10.4804688 C7,10.9353218 7.13382206,11.2709515 7.41298981,11.5479382 C7.70163792,11.8343313 8.06504655,11.9832621 8.48296214,12.0006745 C8.94491082,11.983699 9.29609673,11.8365789 9.58701019,11.5479382 C9.86617794,11.2709515 10,10.9353218 10,10.4804688 C10,10.0256157 9.86617794,9.68998605 9.58701019,9.41299929 C9.30630431,9.13448643 8.96367572,9 8.5,9 Z M17.5,9 C17.0363243,9 16.6936957,9.13448643 16.4129898,9.41299929 C16.1338221,9.68998605 16,10.0256157 16,10.4804688 C16,10.9353218 16.1338221,11.2709515 16.4129898,11.5479382 C16.7039033,11.8365789 17.0550892,11.983699 17.4449019,12.0006272 C17.9349535,11.9832621 18.2983621,11.8343313 18.5870102,11.5479382 C18.8661779,11.2709515 19,10.9353218 19,10.4804688 C19,10.0256157 18.8661779,9.68998605 18.5870102,9.41299929 C18.3063043,9.13448643 17.9636757,9 17.5,9 Z M5,1 L5,4 L8,4 L8,6 L5,6 L5,9 L3,9 L3,6 L0,6 L0,4 L3,4 L3,1 L5,1 Z"
                            id="Combined-Shape" fill="#888"></path>
                    </g>
                </svg>
                <span class="disable-select">{{ 'ADD_CONTACT_LBL' | translate }}</span>
            </mat-list-item>
        </mat-list>
    </mat-menu>

    <mat-menu #headerMenuOperation="matMenu" [class]="'contact-plus-operation-mat-menu'">
        <button mat-menu-item (click)="floatingOperation('star','')">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-star"></mat-icon>
            <span class="disable-select">{{'ADD_TO_FAVORITES' | translate}}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('addList','')">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-account-box-multiple"></mat-icon>
            <span class="disable-select">{{'ADD_LIST_LABEL' | translate}}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('addTags','')">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-tag"></mat-icon>
            <span class="disable-select">{{'ADD_TAGS' | translate}}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('email','')" [disabled]="!isShowSendEmailOption">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-email"></mat-icon>
            <span class="disable-select">{{'EMAIL_LBL' | translate}}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('event','')" [disabled]="!isShowCalendarOption">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-calendar-plus"></mat-icon>
            <span class="disable-select">{{'CALENDAR_EVENT' | translate}}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('audioCall','')" [disabled]="!isShowTalkOptions">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-phone"></mat-icon>
            <span class="disable-select">{{'VOICE_CALL' | translate}}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('videoCall','')" [disabled]="!isShowTalkOptions">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-video"></mat-icon>
            <span class="disable-select">{{'VIDIO_CALL' | translate}}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('chat','')" [disabled]="!isShowTalkOptions">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-message-text"></mat-icon>
            <span class="disable-select">{{'SEND_A_MSG_LBL' | translate}}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('broadcast','')" [disabled]="!isShowTalkOptions">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-bullhorn"></mat-icon>
            <span class="disable-select">{{'BROADCAST' | translate}}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('shareScreen','')" [disabled]="!isShowTalkOptions" *ngIf="!isOnMobile">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-monitor-share"></mat-icon>
            <span class="disable-select">{{'SHARE_SCREEN' | translate}}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('exportContact','')">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-export"></mat-icon>
            <span class="disable-select">{{ 'EXPORT_CONTACTS' | translate }}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('printContact','')">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-printer"></mat-icon>
            <span class="disable-select">{{ 'PRINT_DLG_HEADER' | translate }}</span>
        </button>
        <button mat-menu-item (click)="floatingOperation('remove','')">
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-close"></mat-icon>
            <span class="disable-select">{{ 'REMOVE' | translate }}</span>
        </button>
    </mat-menu>
</div>

<div class="contact-add-menu-container">
    <button mat-fab (click)="createContact()">
        <mat-icon class="mdi-24px" fontSet="mdi" fontIcon="mdi-plus"></mat-icon>
    </button>
</div>
<ng-template  #deleteIcon>
    <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ng-star-inserted">
        <g id="Icon/product/delete-new" stroke="none" stroke-width="1" fill-rule="evenodd">
            <path fill="#8B96A0"
                d="M18,7 L6,7 L6,18.2857143 C6,19.7746499 7.19131256,21 8.66666667,21 L15.3333333,21 C16.8086874,21 18,19.7746499 18,18.2857143 L18,7 Z M8,9 L16,9 L16,18.2857143 C16,18.6824929 15.6913126,19 15.3333333,19 L8.66666667,19 L8.57834889,18.9935231 C8.25938319,18.9465317 8,18.649428 8,18.2857143 L8,9 Z M13,3 C13.7404864,3 14.3869825,3.40242038 14.7327215,4.00049436 L18,4 C18.5522847,4 19,4.44771525 19,5 C19,5.55228475 18.5522847,6 18,6 L6,6 C5.44771525,6 5,5.55228475 5,5 C5,4.44771525 5.44771525,4 6,4 L9.26760632,3.99992752 C9.61342606,3.40216612 10.2597476,3 11,3 L13,3 Z"
                id="Combined-Shape">
            </path>
        </g>
    </svg>
</ng-template>
<ng-template  #editIcon>
    <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ng-star-inserted">
        <title>Icon/product/edit</title>
        <g id="Icon/product/edit" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icon-24px" transform="translate(3.000000, 2.997500)" fill="#8B96A0">
                <path d="M0,14.2525 L0,18.0025 L3.75,18.0025 L14.81,6.9425 L11.06,3.1925 L0,14.2525 L0,14.2525 Z M17.71,4.0425 C18.1,3.6525 18.1,3.0225 17.71,2.6325 L15.37,0.2925 C14.98,-0.0975 14.35,-0.0975 13.96,0.2925 L12.13,2.1225 L15.88,5.8725 L17.71,4.0425 L17.71,4.0425 Z" id="Shape"></path>
            </g>
        </g>
    </svg>
</ng-template>